// extracted by mini-css-extract-plugin
export default {"blockSelector":"style_blockSelector__+6CTV","carouselContainer":"style_carouselContainer__GFbAx","uninteracted":"style_uninteracted__LPE9q","breathe":"style_breathe__UnVwT"};